import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MaterialTable, { Column, MTableToolbar } from 'material-table';
import Button from '@material-ui/core/Button';
import { RowDataCompleted, RedesignReasons, ManuCompOrderFilterData } from 'src/reducers/completeorderfile';
import Fab from '@material-ui/core/Fab';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import DescriptionSharpIcon from '@material-ui/icons/DescriptionSharp';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { forwardRef } from 'react';
import { Icons } from 'material-table';
import {
    Tooltip,
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    DialogProps,
    FormControlLabel,
    withStyles,
    Typography,
    Radio,
    RadioGroup,
    Badge,
    Box
} from '@material-ui/core';
// import Input from '@material-ui/core/Input';
// import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
// import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import VisibilityIcon from '@material-ui/icons/Visibility';
// import RedoIcon from '@material-ui/icons/Redo';
// import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
// import StarHalfIcon from '@material-ui/icons/StarHalf';
import { ManufacturerData, TatData } from 'src/reducers/fileUpload';
import PlayCircleFilledTwoToneIcon from '@material-ui/icons/PlayCircleFilledTwoTone';
import { UserDetail } from 'src/reducers/user';
import FilterListIcon from '@material-ui/icons/FilterList';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { defaultDesignReadyData, maxDayCount } from 'src/actions/completeOrderAction';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@material-ui/core';

interface TableStateDate {
    columns: Array<Column<RowDataCompleted>>;
    data: RowDataCompleted[];
}

interface SubitReDesignCodes {
    producttype: string;
    category: string;
    reason: string;
}

const defaultFilterData: ManuCompOrderFilterData = {
    // pdownload: 'all',
    // pqc_required: 'all',
    prange: 'Custom',
    fdate: new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000)),
    tdate: new Date()
};

export interface ManuCompleteOrderPageViewDateProps {
    completeOrderData: RowDataCompleted[];
    isDownloading: boolean;
    redesignReasons: RedesignReasons[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onRowClickFbStatus: (orderid: string, rowData: string, feedbackreview: string) => void;
    onDownloadClick: (filePath: string, fileName: string) => void;
    // onDownloadClick: (orderno: string, fileName: string) => void;
    // onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted) => void;
    // onBulkDownloadIndividual: (completedData: RowDataCompleted[] | RowDataCompleted) => void;
    onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted, isRetry?: boolean) => void;
    onBulkDownloadIndividual: (completedData: RowDataCompleted[] | RowDataCompleted, isRetry?: boolean) => void;
    printClient: (completedData: RowDataCompleted) => void;
    onBulkDownloadStl: (completedData: RowDataCompleted[] | RowDataCompleted, filetype: string) => void;
    // onFileName:(fileName: string) => void;
    fromDate: (fromdate: string) => void;
    toDate: (todate: string) => void;
    dateFilter: () => void;
    dateReset: () => void;

    orderDataTat: TatData[];
    orderDataManufacturer: ManufacturerData[];
    approvalRequired: (array: Array<object>) => void;
    redesignRequest: (columns: Object) => void;
    openVideoPlayerURL: (fullPath: string[], fpath: string) => void;

    userInfo: UserDetail;

    redirectDesignReady: Boolean;

    onFilterChange: (data: ManuCompOrderFilterData) => void;
     // Add these new properties:
    //  failedFiles: Array<{ fname: string; orderno: string }>;
    failedFiles: Array<{ fname: string; orderno: string; fileType?: string; caseCount?: number }>;
     showFailedFilesDialog: boolean;
     failedFilesMessage: string;
     closeFailedFilesDialog: () => void;
}
export const tableIcons: Icons = {
    Export: forwardRef((props, ref) => <DescriptionSharpIcon {...props} ref={ref} />)
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 800,
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        buttonSend: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '12px',
            position: 'relative'
        },
        root1: {
            display: 'flex',
            height: '30vh'
        },
        fileUpload: {
            textAlign: 'center',
            fontSize: '18px',
            color: '#808080',
            height: '20vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderStyle: 'dotted',
            '&:hover': {
                border: '4px solid #ff0000'
            }
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        reasonBox: {
            minWidth: '500px'
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: '5px',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(1),
        },
        HeadinG: {
            margin: theme.spacing(1),
            '& .MuiInputBase-input': {
                fontSize: '0.9rem'
            },
            '& .MuiButton-label': {
                fontSize: '0.7rem'
            },
            fontSize: '0.9rem'
        },
        qcreq: {
            fontSize: '10px',
            textAlign: 'right',
            paddingRight: '24px',
            fontStyle: 'italic',
            color: 'red'
        },
        mtable: {
            '& .MuiButton-root': {
                fontSize: '12px',
                textTransform: 'capitalize'
            },
            '& .MuiIconButton-root': {
                padding: '0px 5px',
                borderRadius: '0%',
                '&:hover': {
                    backgroundColor: 'transparent'
                }
            }
        },
        svg: {
            maxHeight: '20px'
        },
        svgOutline: {
            cursor: 'pointer',
            padding: '12px',
            flex: '0 0 auto',
            color: 'rgba(0, 0, 0, 0.54)',
            overflow: 'visible',
            fontSize: '1.5rem',
            textAlign: 'center',
            borderRadius: '50%',
            transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
        },
        radioButtonStyle: {
            fontSize: '0.8rem'
        }
    })
);

const CssTextField = withStyles({
    root: {
        '& .MuiInputBase-root.Mui-disabled': {
            color: '#000',
            fontSize: '0.9rem'
        },
    },
})(TextField);

const ManuCompleteOrderPageViewDate: React.StatelessComponent<ManuCompleteOrderPageViewDateProps> = (props) => {
    const classes = useStyles({});

    const [fullWidth] = React.useState(true);
    const [maxWidth] = React.useState<DialogProps['maxWidth']>('md');

    const [fullWidthDownload] = React.useState(true);
    const [maxWidthDownload] = React.useState<DialogProps['maxWidth']>('sm');

    const [tat, setTat] = React.useState('Next Day 7 AM');

    const [manufactType, saveManufactType] = React.useState('In-House');
    const [ptype, setPtype] = React.useState('');
    const [ptypeModel, setPtypeModel] = React.useState('');
    const [category, setCategory] = React.useState('');
    const [categoryArray, setCategoryArray] = React.useState<string[]>([]);
    const [categoryModelArray, setCategoryModelArray] = React.useState<string[]>([]);
    const [categoryModel, setCategoryModel] = React.useState('');
    const [reason, setReason] = React.useState<SubitReDesignCodes[]>([]);
    const [reasonModel, setReasonModel] = React.useState<SubitReDesignCodes[]>([]);
    const [msg, setMsg] = React.useState('');

    const [msgApp, setMsgApp] = React.useState('');
    const [orderno, setOrderno] = React.useState('');
    // const [userName, setuserName] = React.useState('');

    // const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    // const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    //     setAnchorEl(event.currentTarget);
    // };
    // const handleClose = () => {
    //     setAnchorEl(null);
    // };

    // const duplicatePtype = (data: RedesignReasons[]) => {
    //     return Array.from(new Set(data.map(a => a.producttype)))
    //         .map(id => {
    //             return data.find(a => a.producttype === id);
    //         });
    // };

    const [downIndi, setDownIndi] = React.useState(false);

    const [openRe, setOpenRe] = React.useState(false);
    const [openDesignReason, setOpenDesignReason] = React.useState(false);
    const [openModelReason, setOpenModelReason] = React.useState(false);

    const duplicateCateDesign = (data: RedesignReasons[]) => {
        return Array.from(new Set(data.map(a => a.category)))
            .map(id => {
                return data.find(a => a.category === id && a.producttype !== 'Model');
            });
    };

    const duplicateCateModel = (data: RedesignReasons[]) => {
        return Array.from(new Set(data.map(a => a.category)))
            .map(id => {
                return data.find(a => a.category === id && a.producttype === 'Model');
            });
    };

    const changeDesignCategory = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            setCategory(event.target.value);
            setOpenDesignReason(true);
        } else {
            setReason(reason.filter((allReasons) => allReasons.category !== event.target.value));
            const indexofCheck = categoryArray.indexOf(event.target.value);
            categoryArray.splice(indexofCheck !== -1 ? indexofCheck : 0, 1);
            setCategoryArray(categoryArray);
        }
    };
    const changeModelCategory = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            setCategoryModel(event.target.value);
            setOpenModelReason(true);
        } else {
            setReasonModel(reasonModel.filter((allReasons) => allReasons.category !== event.target.value));
            const indexofCheck = categoryModelArray.indexOf(event.target.value);
            categoryModelArray.splice(indexofCheck !== -1 ? indexofCheck : 0, 1);
            setCategoryModelArray(categoryModelArray);
        }
    };

    const changeDesignReason = (event: React.ChangeEvent<HTMLInputElement>) => {

        const newArray: SubitReDesignCodes = {
            producttype: 'Design',
            category: category,
            reason: event.target.value
        };
        reason.push(newArray);
        setReason(reason);
        categoryArray.push(category);
        setCategoryArray(categoryArray);
        setOpenDesignReason(false);
    };
    const changeModelReason = (event: React.ChangeEvent<HTMLInputElement>) => {

        const newArrayModel: SubitReDesignCodes = {
            producttype: 'Model',
            category: categoryModel,
            reason: event.target.value
        };
        reasonModel.push(newArrayModel);
        setReasonModel(reasonModel);
        categoryModelArray.push(categoryModel);
        setCategoryModelArray(categoryModelArray);
        setOpenModelReason(false);
    };

    const handleCloseRe = () => {
        setOpenRe(false);
    };
    const onCloseDesignReason = () => {
        setOpenDesignReason(false);
    };
    const onCloseModelReason = () => {
        setOpenModelReason(false);
    };

    const [openAppro, setOpenAppro] = React.useState(false);
    const handleClickOpenApp = (ordernumber: string) => {
        setMsgApp('');
        setOrderno(ordernumber);
        setOpenAppro(true);
    };
    const handleCloseApp = () => {
        setOpenAppro(false);
    };
    const handleSubmitApp = () => {
        setOpenAppro(false);
        const array = [{
            orderno: orderno,
            approval_reqd: '1',
            remarks: msgApp.replace(/[\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/, '').replace(/\"/g, '')
        }];
        props.approvalRequired(array);
    };

    const [page, setPage] = React.useState(0);
    const [size, setSize] = React.useState(5);
    const [selectedRowsArray, setSelectedRowsArray] = React.useState<RowDataCompleted[]>([]);

    // Add new function to clear selections
    const clearSelections = () => {
        setSelectedRowsArray([]);
    };
    const handleSelectAll = (tableData: RowDataCompleted[]) => {
        setSelectedRowsArray(tableData.slice(page * size, (page * size) + size));
    };
    const handleSelectOne = (tableData: RowDataCompleted) => {

        if (tableData.orderno) {
            setSelectedRowsArray((items: RowDataCompleted[]) => {
                if (items.find(_d => _d.orderno === tableData.orderno)?.orderno) {
                    return items.filter((item) => item.orderno !== tableData.orderno);
                }
                const newItems = items.concat([tableData]);
                return newItems;
            });
        }

    };

    const downloadFiletypes = ['STL', 'PTS', '3OX'];
    const [openDownload, setOpenDownload] = React.useState(false);
    const [fileTypes, setFileTypes] = React.useState<string[]>([]);
    const [downloadType, setDownloadType] = React.useState('multiple');
    const isReloadingRef = React.useRef(false);
    const downloadAfterReloadRef = React.useRef<RowDataCompleted[]>([]);
    const [localCompleteOrderData, setLocalCompleteOrderData] = React.useState<RowDataCompleted[]>([]);

    // const openDownloadDialog = (rowdata: RowDataCompleted[] | RowDataCompleted, type: String) => {
    //     if (type === 'zip' && selectedRowsArray.length === 1) {
    //         props.onBulkDownload(selectedRowsArray);
    //         // setTimeout(() => window.location.reload(), 1000);
    //     } else {
    //         if (type === 'zip') { setDownIndi(true); setDownloadType('multiple'); } else { setDownIndi(false); }
    //         setFileTypes([]);
    //         setOpenDownload(true);
    //     }
    // };
    React.useEffect(
        () => {
            if (props.completeOrderData && props.completeOrderData.length > 0) {
                setLocalCompleteOrderData(props.completeOrderData);
            }
        },
        [props.completeOrderData]
    );
     // Modified reload handler
    const handleReload = () => {
        isReloadingRef.current = true;
        props.reload();
    };

    const openDownloadDialog = (rowdata: RowDataCompleted[] | RowDataCompleted, type: String) => {
        // Store current data before download
        if (localCompleteOrderData.length > 0) {
            downloadAfterReloadRef.current = localCompleteOrderData;
        }

        if (type === 'zip' && selectedRowsArray.length === 1) {
            props.onBulkDownload(selectedRowsArray);
            setTimeout(() => handleReload(), 1000);
        } else {
            if (type === 'zip') { 
                setDownIndi(true); 
                setDownloadType('multiple'); 
                setTimeout(() => handleReload(), 1000);
            } else { 
                setDownIndi(false); 
            }
            setFileTypes([]);
            setOpenDownload(true);
        }
    };
    const filetypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            fileTypes.push(event.target.value);
            const tempType = fileTypes.filter((v, i) => fileTypes.indexOf(v) === i);
            setFileTypes(tempType);
        } else {
            setFileTypes(fileTypes.filter((allTypes) => allTypes !== event.target.value));
        }
    };

    const closeDownloadDialog = () => {
        setOpenDownload(false);
    };
    const submitStlDownload = () => {
        setOpenDownload(false);
        props.onBulkDownloadStl(selectedRowsArray, fileTypes.toString());
        clearSelections(); 
        setTimeout(() => handleReload(), 1000);
    };
    const submitZipDownload = () => {
        setOpenDownload(false);
        if (downloadType === 'single') {
            props.onBulkDownload(selectedRowsArray);
        } else {
            props.onBulkDownloadIndividual(selectedRowsArray);
        }
        setTimeout(() => handleReload(), 1000);
    };

    const [state] = React.useState<TableStateDate>({
        columns: [
            {
                title: 'Order No',
                field: 'orderno',
                filtering: false,
                render: rowData => (
                    <div>
                        {
                            rowData.qc_required === '0' ?
                                rowData.orderno
                                :
                                rowData.qc_required === '1' ?
                                    <div>
                                        {rowData.orderno}
                                        <div className={classes.qcreq}>
                                            QC Required
                                        </div>
                                    </div>
                                    :
                                    rowData.qc_required === '2' ?
                                        <div>
                                            {rowData.orderno}
                                            <div className={classes.qcreq} onClick={() => handleClickOpenApp(rowData.orderno)} style={{ color: 'green', cursor: 'pointer' }}>
                                                Approve
                                            </div>
                                        </div>
                                        :
                                        rowData.orderno
                        }
                    </div>
                ),
                cellStyle: {
                    fontSize: '13px',
                    padding: '0px'
                }
            },
            // {
            //     title: 'Booking ID',
            //     field: 'refno',
            //     filtering: false,
            //     cellStyle: {
            //         padding: '0px',
            //         fontSize: '12px'
            //     }
            // },
            {
                title: 'Received on',
                field: 'orderdate',
                filtering: false,
                cellStyle: {
                    fontSize: '13px',
                    padding: '0px'
                }
            },
            {
                title: 'File Name',
                field: 'fname',
                filtering: false,
                cellStyle: {
                    fontSize: '13px',
                    padding: '0px'
                }
            },
            {
                title: 'TAT',
                field: 'tat',
                filtering: false,
                cellStyle: {
                    fontSize: '13px',
                    padding: '0px'
                }
            },
            {
                title: 'Due By',
                field: 'dueby',
                filtering: false,
                cellStyle: {
                    fontSize: '13px',
                    padding: '0px'
                }
            },
            {
                title: 'Completed On',
                field: 'completedon',
                filtering: false,
                cellStyle: {
                    fontSize: '13px',
                    padding: '0px',
                    textAlign: 'center'
                }
            },
            {
                title: 'Action',
                field: 'fdownload',
                export: false,
                // cellStyle: {
                //   backgroundColor: '#039be5',
                //   color: '#FFF'
                // },
                render: rowData => (
                    <div style={{ display: 'flex' }}>
                        {props.userInfo.labCode === '05033' && <Tooltip title="Print Client" placement="top">
                            <div className={classes.svgOutline}>
                                <img src="/assets/svg/3dprinting.png" onClick={() => props.printClient(rowData)} alt="3D Print" className={classes.svg} />
                            </div>
                        </Tooltip>}
                        <Tooltip title="View" placement="top">
                            <IconButton aria-label="view" onClick={() => props.onRowClick((JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid))}>
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        {/* <Tooltip title="Re-Design" placement="top">
                            <IconButton aria-label="view" onClick={() => handleClickOpenRe(rowData.orderno, rowData.labname, rowData.destination)}>
                                <RedoIcon fontSize="small" />
                            </IconButton>
                        </Tooltip> */}
                        {
                            rowData.feedback === '0' ? (
                                <Tooltip title="Pending for Feedback" placement="top">
                                    <IconButton
                                        aria-label="view"
                                        onClick={() => 
                                            props.onRowClickFbStatus(
                                                (JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid), (JSON.parse(JSON.stringify(rowData)).feedback)
                                            )
                                        }
                                    >
                                        <StarBorderIcon style={{ color: 'black', fontSize: 25 }} /> {/* Question Mark Star */}
                                    </IconButton>
                                </Tooltip>
                            ) : rowData.feedback === '1' ? (
                                <Tooltip title="Completed" placement="top">
                                    <IconButton
                                        aria-label="view"
                                        onClick={() => 
                                            props.onRowClickFbStatus(
                                                (JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid), (JSON.parse(JSON.stringify(rowData)).feedback)
                                            )
                                        }
                                    >
                                        <StarBorderIcon style={{ color: 'green', fontSize: 25 }} />
                                    </IconButton>
                                </Tooltip>
                            ) : rowData.feedback === '2' ? (
                                <Tooltip title="Pending for Review" placement="top">
                                    <IconButton
                                        aria-label="view"
                                        onClick={() => 
                                            props.onRowClickFbStatus(
                                                (JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid), (JSON.parse(JSON.stringify(rowData)).feedback)
                                            )
                                        }
                                    >
                                        <StarBorderIcon style={{ color: 'blue', fontSize: 25 }} />
                                    </IconButton>
                                </Tooltip>
                            ) : rowData.feedback === '3' ? (
                                <Tooltip title="Review Completed" placement="top">
                                    <IconButton
                                        aria-label="view"
                                        onClick={() => 
                                            props.onRowClickFbStatus(
                                                (JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid), (JSON.parse(JSON.stringify(rowData)).feedback)
                                            )
                                        }
                                    >
                                        <StarBorderIcon style={{ color: 'orange', fontSize: 25 }} />
                                    </IconButton>
                                </Tooltip>
                            ) : null
                        }
                        {/* {rowData.fdownload === '0' ?
                            <Tooltip title="Not yet Downloaded" placement="top">
                                <div style={{ width: '20px', height: '20px', background: 'red', borderRadius: '50%', padding: '5px', margin: 'auto' }} />
                            </Tooltip>
                            :
                            <Tooltip title="Downloaded" placement="top">
                                <div style={{ width: '20px', height: '20px', background: 'green', borderRadius: '50%', padding: '5px', margin: 'auto' }} />
                            </Tooltip>
                        } */}
                        {
                            (parseInt(rowData.msgcnt, 10) && parseInt(rowData.msgcnt, 10) > 0) ?
                                <IconButton aria-label="msg" disabled>
                                    <Badge color="secondary" variant="dot">
                                        <MailOutlineIcon fontSize="small" />
                                    </Badge>
                                </IconButton>
                                : null
                        }
                        {
                            rowData.vfiles !== '' ?
                                <Tooltip title="Video" placement="top">
                                    <IconButton
                                        color="primary"
                                        onClick={() => props.openVideoPlayerURL(rowData.vfiles.split(','), rowData.fpath)}
                                        aria-label="view video"
                                    >
                                        <PlayCircleFilledTwoToneIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                : null
                        }
                        <Tooltip title="Download" placement="top">
                                    <IconButton
                                        aria-label="download"
                                        onClick={() => props.onDownloadClick((JSON.parse(JSON.stringify(rowData)).fpath), (JSON.parse(JSON.stringify(rowData)).fname))}
                                    // className={classes.iconPadding}
                                    >
                                        <CloudDownloadIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                    </div>
                ),
                cellStyle: {
                    padding: '0px'
                }
            }
        ],
        // data: props.completeOrderData
        data: localCompleteOrderData.length > 0 ? localCompleteOrderData : props.completeOrderData
    });
    
    const [filterOpen, setFilterOpen] = React.useState(false);
    const [filterData, setFilterData] = React.useState<ManuCompOrderFilterData>(props.redirectDesignReady ? defaultDesignReadyData : defaultFilterData);
    // const [filterData, setFilterData] = React.useState<ManuCompOrderFilterData>(props.redirectDesignReady ? defaultDesignReadyData : defaultFilterData);
    const handleChangeFilterData = (fprange: string, ffdate: Date, ftdate: Date) => {
        if (fprange !== 'Custom') {
            ffdate = new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000));
            ftdate = new Date();
        }
        if (fprange === 'Custom' && ffdate > ftdate) {
            setFilterData({
                // pdownload: fpdownload,
                prange: fprange,
                fdate: ftdate,
                tdate: ffdate,
                // pqc_required: qcRequired
            });
        } else {
            setFilterData({
                // pdownload: fpdownload,
                prange: fprange,
                fdate: ffdate,
                tdate: ftdate,
                // pqc_required: qcRequired
            });
        }
    };

    const submitFilter = () => {
        setFilterOpen(false);
        props.onFilterChange(filterData);
    };
    const resetFilter = () => {
        setFilterData(defaultFilterData);
    };
    React.useEffect(
        () => {
            if (isReloadingRef.current && props.completeOrderData.length > 0) {
                isReloadingRef.current = false;
                
                // Always reset local data to the most recent complete order data
                setLocalCompleteOrderData(props.completeOrderData);
                
                // Reset any download-related refs
                downloadAfterReloadRef.current = [];
            }
        },
        [props.completeOrderData]
    );

    // React.useEffect(
    //     () => {
    //         if (isReloadingRef.current && props.completeOrderData.length > 0) {
    //             isReloadingRef.current = false;
    //             // Restore the table data if needed
    //             if (downloadAfterReloadRef.current.length > 0) {
    //                 setLocalCompleteOrderData(downloadAfterReloadRef.current);
    //                 downloadAfterReloadRef.current = [];
    //             }
    //         }
    //     },
    //     [props.completeOrderData]
    // );
    
    // Add these new state variables in the component
    const [selectedFailedFiles, setSelectedFailedFiles] = React.useState<Array<{ fname: string; orderno: string }>>([]);

    // Add these handler functions
    const handleFailedFileCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, file: { fname: string; orderno: string }) => {
        if (event.target.checked) {
            setSelectedFailedFiles([...selectedFailedFiles, file]);
        } else {
            setSelectedFailedFiles(selectedFailedFiles.filter(item =>
                !(item.fname === file.fname && item.orderno === file.orderno)
            ));
        }
    };
    const handleSelectAllFailedFiles = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            setSelectedFailedFiles([...props.failedFiles]);
        } else {
            setSelectedFailedFiles([]);
        }
    };
    // React.useEffect(
    //     () => {
    //         if (props.showFailedFilesDialog) {
    //             setSelectedFailedFiles([]);
    //         }
    //     },
    //     [props.showFailedFilesDialog]
    // );
    // const handleRetryDownload = () => {
    //     if (selectedFailedFiles.length > 0) {
    //         // Create a new array of RowDataCompleted objects from the selected failed files
    //         const filesToDownload = props.completeOrderData.filter(item =>
    //             selectedFailedFiles.some(file =>
    //                 file.fname === item.fname && file.orderno === item.orderno
    //             )
    //         );

    //         // Close the dialog
    //         props.closeFailedFilesDialog();

    //         // Trigger the download for selected files
    //         if (filesToDownload.length > 0) {
    //             props.onBulkDownloadIndividual(filesToDownload, true);
    //              // Ensure reload is triggered
    //             handleReload();
    //         }
    //     }
    // };
    // const [retryCountMap, setRetryCountMap] = React.useState<Record<string, number>>({});
    
    // React.useEffect(
    //         () => {
    //         if (props.showFailedFilesDialog) {
    //             // Initialize retry counts for any new files
    //             const newRetryCountMap = {...retryCountMap};
    //             props.failedFiles.forEach(file => {
    //             const fileKey = `${file.orderno}-${file.fname}`;
    //             if (newRetryCountMap[fileKey] === undefined) {
    //                 newRetryCountMap[fileKey] = 0;
    //             }
    //             });
    //             setRetryCountMap(newRetryCountMap);
                
    //             // Automatically select all files that haven't exceeded retry limit
    //             const availableFiles = props.failedFiles.filter(file => {
    //             const fileKey = `${file.orderno}-${file.fname}`;
    //             return (newRetryCountMap[fileKey] || 0) < 3;
    //             });
                
    //             // Set the selected files
    //             setSelectedFailedFiles(availableFiles);
    //         }
    //         },
    //         [props.showFailedFilesDialog, props.failedFiles]
    //     );
    
    // Modify the handleRetryDownload function to track retry counts
    // const handleRetryDownload = () => {
    //     if (selectedFailedFiles.length > 0) {
    //         // Update retry counts for selected files
    //         const updatedRetryCountMap = {...retryCountMap};
    //         selectedFailedFiles.forEach(file => {
    //             const fileKey = `${file.orderno}-${file.fname}`;
    //             updatedRetryCountMap[fileKey] = (updatedRetryCountMap[fileKey] || 0) + 1;
    //         });
    //         setRetryCountMap(updatedRetryCountMap);
            
    //         // Create filtered list with only files that haven't exceeded retry limit
    //         const filesToDownload = props.completeOrderData.filter(item =>
    //             selectedFailedFiles.some(file => {
    //                 const fileKey = `${file.orderno}-${file.fname}`;
    //                 const retryCount = updatedRetryCountMap[fileKey] || 0;
    //                 return file.fname === item.fname && file.orderno === item.orderno && retryCount <= 3;
    //             })
    //         );

    //         props.closeFailedFilesDialog();

    //         if (filesToDownload.length > 0) {
    //             props.onBulkDownloadIndividual(filesToDownload, true);
    //         }
    //     }
    // };
    const [retryCountMap, setRetryCountMap] = React.useState<{[key: string]: number}>({});
    React.useEffect(
            () => {
            if (props.showFailedFilesDialog) {
                // Initialize retry counts for any new files
                const newRetryCountMap = {...retryCountMap};
                props.failedFiles.forEach(file => {
                const fileKey = `${file.orderno}-${file.fname}`;
                if (newRetryCountMap[fileKey] === undefined) {
                    newRetryCountMap[fileKey] = 0;
                }
                });
                setRetryCountMap(newRetryCountMap);
                // console.log(newRetryCountMap, 'newRetryCountMap');
                
                // Automatically select all files that haven't exceeded retry limit
                const availableFiles = props.failedFiles.filter(file => {
                const fileKey = `${file.orderno}-${file.fname}`;
                return (newRetryCountMap[fileKey] || 0) < 3;
                });
                // console.log(availableFiles, 'availableFiles');

                // Set the selected files
                setSelectedFailedFiles(availableFiles);
            }
            },
            [props.showFailedFilesDialog, props.failedFiles]
        );

    // Modify the handleRetryDownload function to track retry counts
    const handleRetryDownload = () => {
        if (selectedFailedFiles.length > 0) {
            // Update retry counts for selected files
            const updatedRetryCountMap = {...retryCountMap};
            selectedFailedFiles.forEach(file => {
                const fileKey = `${file.orderno}-${file.fname}`;
                updatedRetryCountMap[fileKey] = (updatedRetryCountMap[fileKey] || 0) + 1;
            });
            // console.log(updatedRetryCountMap, 'updatedRetryCountMap');
            // console.log(selectedFailedFiles, 'selectedFailedFiles');

            setRetryCountMap(updatedRetryCountMap);
            
            // Create filtered list with only files that haven't exceeded retry limit
            const filesToDownload = localCompleteOrderData.filter(item =>
                selectedFailedFiles.some(file => {
                    const fileKey = `${file.orderno}-${file.fname}`;
                    const retryCount = updatedRetryCountMap[fileKey] || 0;
                    return file.fname === item.fname && file.orderno === item.orderno && retryCount <= 3;
                })
            );
            props.closeFailedFilesDialog();

            // if (filesToDownload.length > 0) {
            //     props.onBulkDownloadIndividual(filesToDownload, true);
            // }
            if (filesToDownload.length > 0) {
                if (downloadType === 'single') {
                  props.onBulkDownload(filesToDownload, true); 
                } else {
                  props.onBulkDownloadIndividual(filesToDownload, true); 
                }
            }
        }
    };
    // const handleRetryDownload = () => {
    //     console.log('Starting handleRetryDownload function');
    //     console.log('Current selectedFailedFiles:', selectedFailedFiles);
        
    //     if (selectedFailedFiles.length > 0) {
    //         console.log('Selected failed files count:', selectedFailedFiles.length);
    //         console.log('Initial selectedFailedFiles:', selectedFailedFiles);
    
    //         // Clone the current retry count map
    //         const updatedRetryCountMap = { ...retryCountMap };
    //         console.log('Initial retryCountMap:', retryCountMap);
    //         console.log('Created new updatedRetryCountMap:', updatedRetryCountMap);
    
    //         // Update retry counts for selected files
    //         console.log('Updating retry counts for each selected file...');
    //         selectedFailedFiles.forEach(file => {
    //             const fileKey = `${file.orderno}-${file.fname}`;
    //             console.log(`Processing file: ${fileKey}`);
    //             console.log(`Current retry count for ${fileKey}:`, updatedRetryCountMap[fileKey] || 0); 
                
    //             updatedRetryCountMap[fileKey] = (updatedRetryCountMap[fileKey] || 0) + 1;
                
    //             console.log(`Updated retry count for ${fileKey} to:`, updatedRetryCountMap[fileKey]);
    //         });
    
    //         console.log('Final updatedRetryCountMap after updates:', updatedRetryCountMap);
    //         console.log('Setting retryCountMap state...');
    //         setRetryCountMap(updatedRetryCountMap);
    //         console.log('retryCountMap state set');
    
    //         // Filter files that haven't exceeded retry limit
    //         console.log('Filtering completeOrderData to find matching files...');
    //         console.log('completeOrderData length:', props.completeOrderData.length);
    //         console.log('localCompleteOrderData length:', localCompleteOrderData.length);
            
    //         // const filesToDownload = props.completeOrderData.filter(item => {
    //         const filesToDownload = localCompleteOrderData.filter(item => {
    //             console.log(`Checking order item: ${item.orderno} - ${item.fname}`);
                
    //             const matchingFiles = selectedFailedFiles.filter(file => {
    //                 const fileKey = `${file.orderno}-${file.fname}`;
    //                 const retryCount = updatedRetryCountMap[fileKey] || 0;
    //                 const isOrderMatch = file.orderno === item.orderno;
    //                 const isFileMatch = file.fname === item.fname;
    //                 const isUnderLimit = retryCount <= 3;
                    
    //                 console.log(`Comparing with failed file: ${file.orderno} - ${file.fname}`);
    //                 console.log(`Order match: ${isOrderMatch}, File match: ${isFileMatch}, Under limit: ${isUnderLimit}`);
    //                 console.log(`Current retry count: ${retryCount}/3`);
                    
    //                 return isOrderMatch && isFileMatch && isUnderLimit;
    //             });
                
    //             console.log(`Found ${matchingFiles.length} matching failed files for this order item`);
    //             return matchingFiles.length > 0;
    //         });
    
    //         console.log('Files eligible for re-download:', filesToDownload);
    //         console.log('filesToDownload length:', filesToDownload.length);
    
    //         console.log('Closing failed files dialog...');
    //         props.closeFailedFilesDialog();
    //         console.log('Dialog closed');
    
    //         if (filesToDownload.length > 0) {
    //             console.log('Initiating bulk re-download with params:');
    //             console.log('filesToDownload:', filesToDownload);
    //             console.log('isRetry flag:', true);
    //             props.onBulkDownloadIndividual(filesToDownload, true);
    //             console.log('onBulkDownloadIndividual called');
    //         } else {
    //             console.log('No files eligible for re-download. Retry limit exceeded or no matching files found.');
    //         }
    //     } else {
    //         console.log('No failed files selected for retry.');
    //     }
    //     console.log('handleRetryDownload function complete');
    // };
     // Helper function to check if a file has exceeded retry limit
    const hasExceededRetryLimit = (file: { fname: string; orderno: string }): boolean => {
        const fileKey = `${file.orderno}-${file.fname}`;
        return (retryCountMap[fileKey] || 0) >= 3;
    };

    // Helper function to get number of retries for a file
    const getRetryCount = (file: { fname: string; orderno: string }): number => {
        const fileKey = `${file.orderno}-${file.fname}`;
        return retryCountMap[fileKey] || 0;
    };
    const stfFailedFiles = props.failedFiles.filter(file => file.fileType === 'STL');
    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <div>
                        <Tooltip title="Refresh" placement="top" arrow>
                            {/* <Fab color="primary" aria-label="add" style={{ height: '40px', width: '40px', float: 'left', margin: '12px', zIndex: 100 }} onClick={props.reload}> */}
                            <Fab color="primary" aria-label="add" style={{ height: '40px', width: '40px', float: 'left', margin: '12px', zIndex: 100 }} onClick={handleReload}>
                                <AutorenewIcon />
                            </Fab>
                        </Tooltip>
                        <Tooltip title="Filter" placement="top" arrow>
                            <Button
                                id="filterDate"
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                variant="contained"
                                color="primary"
                                onClick={() => setFilterOpen(true)}
                                className={classes.buttonSend}
                            >
                                <FilterListIcon />
                            </Button>
                        </Tooltip>
                        <Dialog
                            open={filterOpen}
                            maxWidth="sm"
                            fullWidth
                            onClose={() => setFilterOpen(false)}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title"><Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>Filter</Typography></DialogTitle>
                            <DialogContent>
                                {/* <Grid container spacing={2}>
                                    <Grid item sm={6}>   
                                        <Typography variant="body1">Download Status</Typography>
                                        <br />
                                        <FormControl variant="outlined" size="small" style={{ width: 200 }}>
                                            <Select
                                                labelId="demo-simple-select-outlined-label-fds"
                                                id="D-status"
                                                onChange={
                                                    (event) => handleChangeFilterData(event.target.value as string, filterData.prange, filterData.fdate, filterData.tdate, filterData.pqc_required)
                                                }
                                                value={filterData.pdownload}
                                            > 
                                                <MenuItem value="Not Downloaded">Not Downloaded</MenuItem>
                                                <MenuItem value="Downloaded">Downloaded</MenuItem>
                                                <MenuItem value="all">All</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item sm={6}>
                                        <Typography variant="body1">QC Required</Typography>
                                        <br />
                                        <FormControl variant="outlined" size="small" style={{ width: 200 }}>
                                            <Select
                                                labelId="demo-simple-select-outlined-label-fds"
                                                id="D-status"
                                                onChange={
                                                    (event) => handleChangeFilterData(filterData.pdownload, filterData.prange, filterData.fdate, filterData.tdate, event.target.value as string)
                                                }
                                                value={filterData.pqc_required}
                                            >
                                                <MenuItem value="all">All</MenuItem>
                                                <MenuItem value="yes">Yes</MenuItem>
                                                <MenuItem value="no">No</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                </Grid> */}
                                {/* <br />
                                <hr />
                                <Typography variant="body1">Completed On</Typography>
                                <br /> */}
                                {/* <Grid container spacing={2}>
                                    <FormControl variant="outlined" size="small" style={{ width: 200 }}>
                                        <Select
                                            labelId="demo-simple-select-outlined-labefsd"
                                            id="range"
                                            value={filterData.prange}
                                            onChange={
                                                (event) => handleChangeFilterData(filterData.pdownload, event.target.value as string, filterData.fdate, filterData.tdate, filterData.pqc_required)
                                            }
                                        >
                                            <MenuItem value="Today">Today</MenuItem>
                                            <MenuItem value="Yesterday">Yesterday</MenuItem>
                                            <MenuItem value="Current Week">Current Week</MenuItem>
                                            <MenuItem value="all">All</MenuItem>
                                            <MenuItem value="Custom">Custom</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid> */}
                                {/* {filterData.prange === 'Custom' && */}
                                    <>
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                            <Grid container justify="space-around" spacing={2}>
                                                <KeyboardDatePicker
                                                    margin="normal"
                                                    minDate={new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000))}
                                                    maxDate={new Date()}
                                                    id="date-picker-dialog"
                                                    label="Start Date"
                                                    format="MM/dd/yyyy"
                                                    value={filterData.fdate}
                                                    name="fdate"
                                                    // onChange={(date: Date) => handleChangeFilterData(filterData.pdownload, filterData.prange, date, filterData.tdate, filterData.pqc_required)}
                                                    onChange={(date: Date) => handleChangeFilterData(filterData.prange, date, filterData.tdate)}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                />
                                                <KeyboardDatePicker
                                                    margin="normal"
                                                    minDate={new Date(new Date().getTime() - (7 * 24 * 60 * 60 * 1000))}
                                                    maxDate={new Date()}
                                                    id="date-picker-dialog-2"
                                                    label="End Date"
                                                    format="MM/dd/yyyy"
                                                    name="tdate"
                                                    value={filterData.tdate}
                                                    onChange={(date: Date) => handleChangeFilterData(filterData.prange, filterData.fdate, date)}
                                                    KeyboardButtonProps={{
                                                        'aria-label': 'change date',
                                                    }}
                                                    helperText={
                                                        maxDayCount(filterData.fdate, filterData.tdate) &&
                                                        filterData.prange === 'Custom' &&
                                                        'Data not more than a week'
                                                    }
                                                />
                                            </Grid>
                                        </MuiPickersUtilsProvider>
                                    </>
                                {/*  } */}
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="primary"
                                    className={classes.HeadinG}
                                    onClick={submitFilter}
                                    disabled={maxDayCount(filterData.fdate, filterData.tdate) && filterData.prange === 'Custom'}
                                >
                                    Submit
                                </Button>
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="secondary"
                                    onClick={resetFilter}
                                    className={classes.HeadinG}
                                >
                                    Reset
                                </Button>
                            </DialogActions>
                        </Dialog>
                        {props.isDownloading === true ? <CircularProgress className={classes.buttonSend} /> : null}
                        {/* <Tooltip title="Export" placement="top" arrow>
                            <Button
                                aria-controls="customized-menu"
                                aria-haspopup="true"
                                variant="contained"
                                color="primary"
                                onClick={handleClick}
                                className={classes.buttonSend}
                            >
                                <NoteAddOutlinedIcon />
                            </Button>
                        </Tooltip> */}
                        {/* <Dialog
                            open={props.showFailedFilesDialog}
                            onClose={props.closeFailedFilesDialog}
                            aria-labelledby="failed-files-dialog-title"
                            fullWidth
                            maxWidth="sm"
                        >
                            <DialogTitle id="failed-files-dialog-title">
                                <Typography style={{ textAlign: 'center', fontWeight: 'bold', color: 'red' }}>
                                    Download Failed Files
                                </Typography>
                            </DialogTitle>
                            <DialogContent dividers>
                                {props.failedFiles && props.failedFiles.length > 0 && (
                                    <div className={classes.failedFilesContainer}>
                                        <Typography variant="subtitle1" style={{ marginBottom: '10px', fontWeight: 'bold' }}>
                                            Files Not Found: {props.failedFiles?.length}
                                        </Typography>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={selectedFailedFiles.length === props.failedFiles.length}
                                                    onChange={handleSelectAllFailedFiles}
                                                    color="primary"
                                                />
                                            }
                                            label="Select All"
                                        />

                                        <TableContainer component={Paper} className={classes.tableContainer}>
                                            <Table aria-label="failed files table" size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell padding="checkbox">Select</TableCell>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Order No</TableCell>
                                                        <TableCell>File Name</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {props.failedFiles.map((file, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell padding="checkbox">
                                                                <Checkbox
                                                                    checked={selectedFailedFiles.some(item =>
                                                                        item.fname === file.fname && item.orderno === file.orderno
                                                                    )}
                                                                    onChange={(event) => handleFailedFileCheckboxChange(event, file)}
                                                                    color="primary"
                                                                />
                                                            </TableCell>
                                                            <TableCell>{index + 1}</TableCell>
                                                            <TableCell>{file.orderno}</TableCell>
                                                            <TableCell>{file.fname}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={handleRetryDownload}
                                    color="primary"
                                    variant="contained"
                                    disabled={selectedFailedFiles.length === 0}
                                >
                                    Retry Download
                                </Button>
                                <Button onClick={props.closeFailedFilesDialog} color="primary">
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog> */}
                        {/* <Dialog
                            open={props.showFailedFilesDialog}
                            onClose={props.closeFailedFilesDialog}
                            aria-labelledby="failed-files-dialog-title"
                            fullWidth
                            maxWidth="sm"
                        >
                            <DialogTitle id="failed-files-dialog-title">
                                <Typography style={{ textAlign: 'center', fontWeight: 'bold', }}>
                                    Failed Downloads
                                </Typography>
                            </DialogTitle>
                            <DialogContent dividers>
                                {console.log(props.failedFiles, '098765')}
                                {props.failedFiles && props.failedFiles.length > 0 && (
                                    <div className={classes.failedFilesContainer}>
                                        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={selectedFailedFiles.length === props.failedFiles.length}
                                                    onChange={handleSelectAllFailedFiles}
                                                    color="primary"
                                                />
                                            }
                                            label="Select All"
                                        />
                                        <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: 'red' }}>
                                            Total: {props.failedFiles?.length}
                                        </Typography>
                                        </Box>
                                        <TableContainer component={Paper} className={classes.tableContainer}>
                                            <Table aria-label="failed files table" size="small">
                                                <TableHead style={{ backgroundColor: '#bdbdbd', whiteSpace: 'nowrap',  overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    <TableRow>
                                                        <TableCell padding="checkbox">Select</TableCell>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Order No</TableCell>
                                                        <TableCell>File Name</TableCell>
                                                        <TableCell>Retry Count</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {props.failedFiles.map((file, index) => {
                                                        const exceededLimit = hasExceededRetryLimit(file);
                                                        const retryCount = getRetryCount(file);
                                                        
                                                        return (
                                                            <TableRow key={index}>
                                                                <TableCell padding="checkbox">
                                                                    <Checkbox
                                                                        checked={selectedFailedFiles.some(item =>
                                                                            item.fname === file.fname && item.orderno === file.orderno
                                                                        )}
                                                                        onChange={(event) => handleFailedFileCheckboxChange(event, file)}
                                                                        color="primary"
                                                                        disabled={exceededLimit}
                                                                    />
                                                                </TableCell>
                                                                <TableCell>{index + 1}</TableCell>
                                                                <TableCell>{file.orderno}</TableCell>
                                                                <TableCell>{file.fname}</TableCell>
                                                                <TableCell>
                                                                    {retryCount}/3
                                                                    {exceededLimit && (
                                                                        <Typography variant="caption" style={{color: 'red', display: 'block', 
                                                                        whiteSpace: 'nowrap',  overflow: 'hidden', textOverflow: 'ellipsis'}}>
                                                                            Max retries exceeded
                                                                        </Typography>
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                )}
                            </DialogContent>
                            <DialogActions>
                            <Button
                                onClick={handleRetryDownload}
                                style={{
                                    backgroundColor: selectedFailedFiles.some(file => !hasExceededRetryLimit(file)) 
                                        ? '#1976d2' : '#f44336',
                                    color: 'white'
                                }}
                                variant="contained"
                                disabled={selectedFailedFiles.length === 0 || selectedFailedFiles.every(file => hasExceededRetryLimit(file))}
                            >
                                Retry Download
                            </Button>
                            <Button onClick={props.closeFailedFilesDialog} color="primary" variant="contained">
                                Close
                            </Button>
                            </DialogActions>
                        </Dialog> */}
                        <Dialog
                            // open={props.showFailedFilesDialog && props.failedFiles.length > 0}
                            open={props.showFailedFilesDialog && props.failedFiles.length > 0 && stfFailedFiles.length === 0}
                            onClose={props.closeFailedFilesDialog}
                            aria-labelledby="failed-files-dialog-title"
                            fullWidth
                            maxWidth="sm"
                        >
                            <DialogTitle id="failed-files-dialog-title">
                                <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    Failed Downloads
                                </Typography>
                            </DialogTitle>
                            <DialogContent dividers>
                                {props.failedFiles && props.failedFiles.length > 0 && (
                                    <div className={classes.failedFilesContainer}>
                                        <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={selectedFailedFiles.length === props.failedFiles.length}
                                                        onChange={handleSelectAllFailedFiles}
                                                        color="primary"
                                                    />
                                                }
                                                label="Select All"
                                            />
                                            <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: 'red' }}>
                                                Total: {props.failedFiles?.length}
                                            </Typography>
                                        </Box>
                                        <TableContainer component={Paper} className={classes.tableContainer}>
                                            <Table aria-label="failed files table" size="small">
                                                <TableHead style={{ backgroundColor: '#bdbdbd', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    <TableRow>
                                                        <TableCell padding="checkbox">Select</TableCell>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Order No</TableCell>
                                                        <TableCell>File Name</TableCell>
                                                        <TableCell>Retry Count</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {props.failedFiles.map((file, index) => {
                                                        const exceededLimit = hasExceededRetryLimit(file);
                                                        const retryCount = getRetryCount(file);

                                                        return (
                                                            <TableRow key={index}>
                                                                <TableCell padding="checkbox">
                                                                    <Checkbox
                                                                        checked={selectedFailedFiles.some(item => item.fname === file.fname && item.orderno === file.orderno)}
                                                                        onChange={(event) => handleFailedFileCheckboxChange(event, file)}
                                                                        color="primary"
                                                                        disabled={exceededLimit}
                                                                    />
                                                                </TableCell>
                                                                <TableCell>{index + 1}</TableCell>
                                                                <TableCell>{file.orderno}</TableCell>
                                                                <TableCell>{file.fname}</TableCell>
                                                                <TableCell>
                                                                    {retryCount}/3
                                                                    {exceededLimit && (
                                                                        <Typography variant="caption" style={{ color: 'red', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                            Max retries exceeded
                                                                        </Typography>
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={handleRetryDownload}
                                    style={{
                                        backgroundColor: selectedFailedFiles.some(file => !hasExceededRetryLimit(file))
                                            ? '#1976d2' : '#f44336',
                                        color: 'white'
                                    }}
                                    variant="contained"
                                    disabled={selectedFailedFiles.length === 0 || selectedFailedFiles.every(file => hasExceededRetryLimit(file))}
                                >
                                    Retry Download
                                </Button>
                                <Button onClick={props.closeFailedFilesDialog} color="primary" variant="contained">
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog
                            open={props.showFailedFilesDialog && stfFailedFiles.length > 0}  // Show dialog only if there are STL files
                            onClose={props.closeFailedFilesDialog}
                            aria-labelledby="failed-files-dialog-title"
                            fullWidth
                            maxWidth="sm"
                        >
                            <DialogTitle id="failed-files-dialog-title">
                                <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    STL Files - Failed Downloads
                                </Typography>
                            </DialogTitle>
                            <DialogContent dividers>
                                {stfFailedFiles && stfFailedFiles.length > 0 && (
                                    <div className={classes.failedFilesContainer}>
                                        {/* <Box style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                            <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: 'green' }}>
                                                STL files available for: {selectedRowsArray.length} orders
                                            </Typography>
                                        </Box>

                                        <Box style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                            <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: 'red' }}>
                                                STL files not available for: {stfFailedFiles.length} orders
                                            </Typography>
                                        </Box> */}
                                        <Box 
                                                style={{ 
                                                    border: '1px solid #e0e0e0', 
                                                    borderRadius: '4px', 
                                                    padding: '12px', 
                                                    marginBottom: '8px' 
                                                }}
                                        >
                                                <Box style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
                                                    <Typography variant="subtitle1" color="textSecondary">
                                                        {/* STL files available for: {caseCount ?? 0} orders */}
                                                        Below files are not available. Please contact support team
                                                    </Typography>
                                                    {/* <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>
                                                        Total: {stfFailedFiles.length}
                                                    </Typography> */}
                                                </Box>
                                                
                                                {/* <Typography variant="subtitle1" color="textSecondary">
                                                    STL files not available for: {selectedRowsArray.length - (caseCount ?? 0)} orders
                                                </Typography> */}
                                        </Box>
                                        <TableContainer component={Paper} className={classes.tableContainer}>
                                            <Table aria-label="failed files table" size="small">
                                                <TableHead style={{ backgroundColor: '#bdbdbd', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    <TableRow>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Order No</TableCell>
                                                        <TableCell>File Name</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {stfFailedFiles.map((file, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell>{index + 1}</TableCell>
                                                            <TableCell>{file.orderno}</TableCell>
                                                            <TableCell>{file.fname}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={props.closeFailedFilesDialog} color="primary" variant="contained">
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog>
                        {/* <Dialog
                            open={props.showFailedFilesDialog}
                            onClose={props.closeFailedFilesDialog}
                            aria-labelledby="failed-files-dialog-title"
                            fullWidth
                            maxWidth="sm"
                        >
                            <DialogTitle id="failed-files-dialog-title">
                                <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    Failed Downloads
                                </Typography>
                            </DialogTitle>
                            <DialogContent dividers>
                                {props.failedFiles && props.failedFiles.length > 0 ? (
                                    <div>
                                        <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={selectedFailedFiles.length === props.failedFiles.filter(file => !hasExceededRetryLimit(file)).length && props.failedFiles.length > 0}
                                                        onChange={handleSelectAllFailedFiles}
                                                        color="primary"
                                                    />
                                                }
                                                label="Select All Available"
                                            />
                                            <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: 'red' }}>
                                                Total: {props.failedFiles.length}
                                            </Typography>
                                        </Box>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="failed files table" size="small">
                                                <TableHead style={{ backgroundColor: '#f5f5f5' }}>
                                                    <TableRow>
                                                        <TableCell padding="checkbox">Select</TableCell>
                                                        <TableCell>S.No</TableCell>
                                                        <TableCell>Order No</TableCell>
                                                        <TableCell>File Name</TableCell>
                                                        <TableCell align="center">Retry Count</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {props.failedFiles.map((file, index) => {
                                                        const exceededLimit = hasExceededRetryLimit(file);
                                                        const retryCount = getRetryCount(file);
                                                        
                                                        return (
                                                            <TableRow 
                                                                key={`${file.orderno}-${file.fname}`}
                                                                style={exceededLimit ? { backgroundColor: '#ffebee' } : {}}
                                                            >
                                                                <TableCell padding="checkbox">
                                                                    <Checkbox
                                                                        checked={selectedFailedFiles.some(item =>
                                                                            item.fname === file.fname && item.orderno === file.orderno
                                                                        )}
                                                                        onChange={(event) => handleFailedFileCheckboxChange(event, file)}
                                                                        color="primary"
                                                                        disabled={exceededLimit}
                                                                    />
                                                                </TableCell>
                                                                <TableCell>{index + 1}</TableCell>
                                                                <TableCell>{file.orderno}</TableCell>
                                                                <TableCell>{file.fname}</TableCell>
                                                                <TableCell align="center">
                                                                    <Box display="flex" flexDirection="column" alignItems="center">
                                                                        <Typography>
                                                                            {retryCount}/3
                                                                        </Typography>
                                                                        {exceededLimit && (
                                                                            <Typography variant="caption" style={{color: 'red'}}>
                                                                                Max retries exceeded
                                                                            </Typography>
                                                                        )}
                                                                    </Box>
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                ) : (
                                    <Typography align="center">No failed downloads to display</Typography>
                                )}
                            </DialogContent>
                            <DialogActions style={{ padding: '16px' }}>
                                <Button
                                    onClick={handleRetryDownload}
                                    style={{
                                        backgroundColor: selectedFailedFiles.length > 0 ? '#1976d2' : '#bdbdbd',
                                        color: 'white'
                                    }}
                                    variant="contained"
                                    disabled={selectedFailedFiles.length === 0}
                                    startIcon={<AutorenewIcon />}
                                >
                                    Retry Download ({selectedFailedFiles.length})
                                </Button>
                                <Button 
                                    onClick={props.closeFailedFilesDialog} 
                                    color="default" 
                                    variant="outlined"
                                >
                                    Close
                                </Button>
                            </DialogActions>
                        </Dialog> */}
                        <Dialog
                            open={openRe}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth={fullWidth}
                            maxWidth={maxWidth}
                        >
                            <DialogTitle id="form-dialog-title">Re-Design Request on Order No : {orderno}</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        {/* <FormControl size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined"
                                                defaultValue="0"
                                                onChange={(event) => setPtype(event.target.value as string)}
                                                value={ptype}
                                            >
                                                <MenuItem value="Design" disabled>Design</MenuItem>
                                                {Array.isArray(props.redesignReasons) && props.redesignReasons.length > 0 && duplicatePtype(props.redesignReasons).map((proType, indexRe1) => (
                                                    proType!.producttype !== 'Model' ? <MenuItem id={proType!.rowno} value={proType!.producttype}>{proType!.producttype}</MenuItem> : null
                                                ))}
                                            </Select>
                                        </FormControl> */}
                                        <CssTextField
                                            fullWidth
                                            disabled
                                            size="small"
                                            onChange={(event) => setPtype(event.target.value as string)}
                                            value={ptype}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    {/* <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-1"
                                                defaultValue="0"
                                                onChange={(event) => setCategory(event.target.value as string)}
                                                value={category}
                                            >
                                                <MenuItem value="0" disabled>Select Category</MenuItem>
                                                {Array.isArray(props.redesignReasons) && props.redesignReasons.length > 0 && duplicateCate(props.redesignReasons).map((cate, indexRe1) => (
                                                    cate!.producttype !== 'Model' ? <MenuItem id={cate!.rowno} value={cate!.category}>{cate!.category}</MenuItem> : null
                                                ))}
                                            </Select>
                                        </FormControl> */}
                                    {
                                        duplicateCateDesign(props.redesignReasons).map((cate, indexRe1) => (
                                            typeof (cate) === 'object' && cate!.producttype !== 'Model' ?
                                                <Grid item key={indexRe1} xs={12} sm={6} md={3}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                id={`category${indexRe1}`}
                                                                checked={categoryArray.indexOf(cate!.category) !== -1 ? true : false}
                                                                value={cate!.category}
                                                                onChange={changeDesignCategory}
                                                                name="category"
                                                            />
                                                        }
                                                        label={<Typography variant="caption">{cate!.category}</Typography>}
                                                    />
                                                </Grid>
                                                : null
                                        ))
                                    }

                                </Grid>
                                <hr style={{ margin: '10px 0' }} />
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        {/* <FormControl size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-3"
                                                defaultValue="0"
                                                onChange={(event) => setPtypeModel(event.target.value as string)}
                                                value={ptypeModel}
                                            >
                                                <MenuItem value="Model" disabled>Model</MenuItem>
                                            </Select>
                                        </FormControl> */}
                                        <CssTextField
                                            fullWidth
                                            disabled
                                            size="small"
                                            onChange={(event) => setPtypeModel(event.target.value as string)}
                                            value={ptypeModel}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container>
                                    {/* <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-4"
                                                defaultValue="0"
                                                onChange={(event) => setCategoryModel(event.target.value as string)}
                                                value={categoryModel}
                                            >
                                                <MenuItem value="0" disabled>Select Category (Model)</MenuItem>
                                                {Array.isArray(props.redesignReasons) && props.redesignReasons.length > 0 && duplicateCate(props.redesignReasons).map((cateModel, indexRe1) => (
                                                    cateModel!.producttype === 'Model' ? <MenuItem id={cateModel!.rowno} value={cateModel!.category}>{cateModel!.category}</MenuItem> : null
                                                ))}
                                            </Select>
                                        </FormControl> */}
                                    {
                                        duplicateCateModel(props.redesignReasons).map((cateModel, indexRe1) => (
                                            typeof (cateModel) === 'object' && cateModel!.producttype === 'Model' ?
                                                <Grid item key={indexRe1} xs={12} sm={6} md={3}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                id={`categoryModel${indexRe1}`}
                                                                checked={categoryModelArray.indexOf(cateModel!.category) !== -1 ? true : false}
                                                                value={cateModel!.category}
                                                                onChange={changeModelCategory}
                                                                name="category"
                                                            />
                                                        }
                                                        label={<Typography variant="caption">{cateModel!.category}</Typography>}
                                                    />
                                                </Grid>
                                                : null
                                        ))
                                    }
                                </Grid>
                                <hr style={{ margin: '10px 0' }} />
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-6"
                                                defaultValue="Next Day 7 AM"
                                                onChange={(event) => setTat(event.target.value as string)}
                                                value={tat}
                                            >
                                                {Array.isArray(props.orderDataTat) && props.orderDataTat.length > 0 && props.orderDataTat.map((tatime, index1) => (
                                                    <MenuItem key={index1} id={tatime.rowno} value={tatime.tattype}>{tatime.tattype}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={6} md={4}>
                                        <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                labelId="demo-simple-select-outlined-label-red1"
                                                id="demo-simple-select-outlined-red1"
                                                required
                                                fullWidth
                                                onChange={(event) => saveManufactType(event.target.value as string)}
                                                value={manufactType}
                                            >
                                                <MenuItem disabled value="">
                                                    <em>Destination</em>
                                                </MenuItem>
                                                <MenuItem value="In-House">
                                                    In-House
                                                </MenuItem>
                                                {Array.isArray(props.orderDataManufacturer) && props.orderDataManufacturer.length > 0 && props.orderDataManufacturer.map((manufactTypes) => (
                                                    <MenuItem key={manufactTypes.rowno} id={manufactTypes.rowno} value={manufactTypes.dest}>{manufactTypes.dest}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={4}>
                                        <FormControl fullWidth variant="outlined" size="small">
                                            <TextField
                                                variant="outlined"
                                                label="Remarks"
                                                multiline
                                                // rows={3}
                                                rowsMax={5}
                                                size="small"
                                                onChange={(event) => setMsg(event.target.value as string)}
                                                value={msg}
                                                required
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions style={{ justifyContent: 'space-between' }}>
                                <Typography variant="caption">
                                    *Please select Reason, TAT, Destination and enter Remarks to submit Re-Design.
                                </Typography>
                                <div className={classes.modal}>
                                    <Button size="small" onClick={handleCloseRe} color="secondary">
                                        Cancel
                                    </Button>
                                    {/* <Button
                                        size="small"
                                        disabled={(msg === '' || (reason.length === 0 && reasonModel.length === 0)) ? true : false}
                                        onClick={handleSubmitRe}
                                        color="primary"
                                    >
                                        Re-Design
                                    </Button> */}
                                </div>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={openDesignReason}
                            onClose={onCloseDesignReason}
                        >
                            <DialogTitle id="form-dialog-title-reasons">{category} :</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <div className={classes.reasonBox}>
                                            <FormControl variant="outlined" fullWidth className={classes.forms}>
                                                <Select
                                                    id="demo-simple-select-outlined-2"
                                                    defaultValue="0"
                                                    fullWidth
                                                    onChange={changeDesignReason}
                                                    value="0"
                                                >
                                                    <MenuItem value="0" disabled>Select Reason</MenuItem>
                                                    {Array.isArray(props.redesignReasons)
                                                        && props.redesignReasons.length > 0
                                                        && props.redesignReasons.map((reasonsRe, indexRe1) => (
                                                            reasonsRe.producttype !== 'Model' && reasonsRe.category === category ?
                                                                <MenuItem key={indexRe1} id={reasonsRe.rowno} value={reasonsRe.code}>{reasonsRe.codedesc}</MenuItem>
                                                                :
                                                                null
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                        </Dialog>
                        <Dialog
                            open={openModelReason}
                            onClose={onCloseModelReason}
                        >
                            <DialogTitle id="form-dialog-title-reasons">{categoryModel} :</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <div className={classes.reasonBox}>
                                            <FormControl variant="outlined" fullWidth className={classes.forms}>
                                                <Select
                                                    id="demo-simple-select-outlined-5"
                                                    defaultValue="0"
                                                    fullWidth
                                                    onChange={changeModelReason}
                                                    value="0"
                                                >
                                                    <MenuItem value="0" disabled>Select Reason (Model)</MenuItem>
                                                    {Array.isArray(props.redesignReasons)
                                                        && props.redesignReasons.length > 0
                                                        && props.redesignReasons.map((reasonsModl, indexRe1) => (
                                                            reasonsModl.producttype === 'Model' && reasonsModl.category === categoryModel ?
                                                                <MenuItem key={indexRe1} id={reasonsModl.rowno} value={reasonsModl.code}>{reasonsModl.codedesc}</MenuItem>
                                                                :
                                                                null
                                                        ))}
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                        </Dialog>
                        <Dialog
                            open={openAppro}
                            onClose={handleCloseApp}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth={fullWidth}
                            maxWidth={maxWidth}
                        >
                            <DialogTitle id="form-dialog-title">Approve Design on Order No : {orderno}</DialogTitle>
                            <DialogContent dividers>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={12}>
                                        <FormControl fullWidth variant="outlined" size="small">
                                            <TextField
                                                variant="outlined"
                                                label="Remarks"
                                                multiline
                                                rows={3}
                                                rowsMax={5}
                                                size="small"
                                                onChange={(event) => setMsgApp(event.target.value as string)}
                                                value={msgApp}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button size="small" onClick={handleCloseApp} color="secondary">
                                    Cancel
                                </Button>
                                <Button size="small" onClick={handleSubmitApp} disabled={msgApp === ''} color="primary">
                                    Approve
                                </Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog
                            open={openDownload}
                            onClose={closeDownloadDialog}
                            aria-labelledby="Dialog-Order-Redesign"
                            fullWidth={fullWidthDownload}
                            maxWidth={maxWidthDownload}
                        // maxWidth={!downIndi ? maxWidthDownload : 'md'}
                        >
                            <DialogTitle id="form-dialog-title">{!downIndi ? 'What to download?' : 'Download As'}</DialogTitle>
                            {!downIndi ?
                                <DialogContent dividers>
                                    <Grid container spacing={2}>
                                        {
                                            downloadFiletypes.map((typeFile, indexRe1) => (
                                                <Grid item key={indexRe1} xs={6} sm={4} md={4}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                id={`filetype${indexRe1}`}
                                                                checked={fileTypes.indexOf(typeFile) > -1}
                                                                value={typeFile}
                                                                onChange={filetypeChange}
                                                                name="Filetype"
                                                            />
                                                        }
                                                        label={typeFile}
                                                    />
                                                </Grid>
                                            ))
                                        }
                                    </Grid>
                                </DialogContent>
                                : <DialogContent dividers>
                                  <Grid container spacing={2}>
                                        <Grid item xs={12}>
                                        <RadioGroup 
                                            aria-label="down-type" 
                                            name="download-type" 
                                            value={downloadType} 
                                            onChange={(e) => setDownloadType(e.target.value)}
                                        >
                                            {/* <FormControlLabel value="single" control={<Radio color="secondary" />} label="Single Compressed File" /> */}
                                           {selectedRowsArray && selectedRowsArray.length <= 10 && ( 
                                                <FormControlLabel value="single" control={<Radio color="secondary" />} label="Single Compressed File" /> 
                                            )}
                                            <FormControlLabel value="multiple" control={<Radio color="secondary" />} label="Individual Files" />
                                        </RadioGroup>
                                        </Grid>
                                        
                                        {selectedRowsArray && selectedRowsArray.length > 0 && (
                                            <Grid item xs={12}>
                                            <Box 
                                                p={2} 
                                                mt={1}
                                                border={1} 
                                                borderColor="divider" 
                                                borderRadius="borderRadius" 
                                                bgcolor="background.paper"
                                            >
                                                <Typography variant="subtitle2" gutterBottom>
                                                Selected Files: {selectedRowsArray.length}
                                                </Typography>
                                                {selectedRowsArray.length <= 5 ? (
                                                <Typography variant="body2" color="textSecondary">
                                                    Estimated download time: 3 - 5 Mins (approx)
                                                </Typography>
                                                ) : selectedRowsArray.length > 5 && selectedRowsArray.length <= 25 ? (
                                                <Typography variant="body2" color="textSecondary">
                                                    Estimated download time: 8 - 10 Mins (approx)
                                                </Typography>
                                                ) : selectedRowsArray.length > 25 && selectedRowsArray.length <= 50 ? (
                                                <Typography variant="body2" color="textSecondary">
                                                    Estimated download time: 15 - 18 Mins (approx)
                                                </Typography>
                                                ) : (
                                                <Typography variant="body2" color="textSecondary">
                                                    Estimated download time: 20 - 25 Mins (approx)
                                                </Typography>
                                                )}
                                            </Box>
                                            </Grid>
                                        )}
                                  </Grid>
                                  </DialogContent>
                                // : <DialogContent dividers>
                                //     <Grid container spacing={2}>
                                //         <RadioGroup aria-label="down-type" name="download-type" value={downloadType} onChange={(e) => setDownloadType(e.target.value)}>
                                //             <FormControlLabel value="single" control={<Radio color="secondary" />} label="Single Compressed File" />
                                //             <FormControlLabel value="multiple" control={<Radio color="secondary" />} label="Individual Files" />
                                //         </RadioGroup>
                                //     </Grid>
                                // </DialogContent>

                            }
                            <DialogActions>
                                {downloadType === 'single' && downIndi && <Typography variant="caption" >
                                    *Note: If selected file size exceeding 1 GB might not download properly, consider downloading as Individual files.
                                </Typography>}
                                <Button size="small" onClick={closeDownloadDialog} color="secondary">
                                    Cancel
                                </Button>
                                {!downIndi && <Button size="small" onClick={submitStlDownload} color="primary">
                                    Download
                                </Button>}
                                {downIndi && <Button size="small" onClick={() => submitZipDownload()} color="primary">
                                    OK
                                </Button>}
                            </DialogActions>
                        </Dialog>
                    </div>
                    <MaterialTable
                        icons={tableIcons}
                        title="Completed Orders"
                        columns={state.columns}
                        // data={props.completeOrderData}
                        data={localCompleteOrderData.length > 0 ? localCompleteOrderData : props.completeOrderData}
                        localization={{
                            toolbar: {
                                nRowsSelected: `${selectedRowsArray.length} order(s) selected`,
                                exportTitle: 'Export as Excel'
                            },
                            header: {
                                actions: ''
                            },
                            body: {
                                emptyDataSourceMessage: 'No orders to display'
                            }
                        }}
                        components={{
                            Toolbar: some => (
                                <div className={classes.mtable}>
                                    <MTableToolbar {...some} />
                                </div>
                            )
                        }}
                        options={{
                            // filtering: true,
                            pageSizeOptions: [5, 10, 25, 50, 100],
                            actionsColumnIndex: -1,
                            headerStyle: {
                                backgroundColor: '#757575',
                                color: '#fff',
                                padding: '5px',
                                textAlign: 'center'
                            },
                            rowStyle: {
                                padding: '0px 0px'
                            },
                            selection: true,
                            sorting: false,
                            exportButton: true,
                            exportAllData: true,
                            selectionProps: (selecrowData: RowDataCompleted) => {
                                const checked = (selectedRowsArray.find(_d => _d.orderno === selecrowData.orderno)?.orderno) ? { checked: true } : { checked: false };
                                return {
                                    ...checked
                                };
                            }
                        }}
                        onSelectionChange={
                            (rows, rowData) => {
                                if (!rowData) {
                                    handleSelectAll(rows);
                                } else {
                                    handleSelectOne(rowData);
                                }
                            }
                        }
                        onChangePage={
                            (pageno) => {
                                // setSelectedRowsArray([]);
                                setPage(pageno);
                            }
                        }
                        onChangeRowsPerPage={
                            (pageSize) => {
                                // setSelectedRowsArray([]);
                                if (pageSize !== size) {
                                    if (pageSize > size) {
                                        setPage(prev => Math.min((Math.max((prev * pageSize) - pageSize, props.completeOrderData.length / 5), 0)));
                                    } else {
                                        setPage(prev => Math.min((Math.max((prev * pageSize) + pageSize, props.completeOrderData.length / 5), 0)));
                                    }
                                }
                                setSize(pageSize);
                            }
                        }
                        // onRowClick={(event, rowData) => {
                        //     props.onRowClick((JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid));
                        // }}
                        actions={[
                            {
                                icon: () => (
                                    (!props.isDownloading ?
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<CloudDownloadIcon />}
                                        >
                                            Download Zip
                                        </Button>
                                        :
                                        <>
                                        </>
                                    )),
                                tooltip: 'Download zip files',
                                isFreeAction: false,
                                onClick: (event, rowdata) => {
                                    if (!props.isDownloading) {
                                        openDownloadDialog(rowdata, 'zip');
                                    }
                                }
                            },
                            {
                                icon: () => (
                                    (!props.isDownloading ?
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<CloudDownloadIcon />}
                                        >
                                            Download STL/PTS/3OX
                                        </Button>
                                        :
                                        <>
                                        </>
                                    )),
                                tooltip: 'Download STL/PTS/3OX files',
                                isFreeAction: false,
                                onClick: (event, rowdata) => {

                                    if (!props.isDownloading) {
                                        openDownloadDialog(rowdata, 'stl');
                                    }
                                }
                            }
                        ]}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default ManuCompleteOrderPageViewDate;



// WEBPACK FOOTER //
// ./src/components/layouts/ManuCompleteOrderPageView.tsx